<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>系统管理</el-breadcrumb-item>
                <el-breadcrumb-item>消息列表</el-breadcrumb-item>
            </el-breadcrumb>
        </template>


        <el-form label-width="80px" class="search-form">
            <el-row :gutter="20">
                <el-form-item label="关键词" prop="keyword">
                    <el-col>
                        <el-input v-model="query.keyword" prefix-icon="Search" @keyup.enter="fetchs()"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="消息类型" prop="category">
                    <el-select v-model="categoryFilter" clearable placeholder="请选择"  allow-create filterable @change="fetchs">
                        <el-option label="出库亏损预警" value="亏损预警"></el-option>
                        <el-option label="办公流程通知" value="流程"></el-option>
                        <el-option label="产品临期提醒" value="产品临期"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="search" @click="fetchs()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-dropdown style="margin-right:20px;">
                <el-button plain type="primary">
                    <el-icon style="margin-right:5px;">
                        <Upload />
                    </el-icon>
                    数据操作
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="action('read')">设置已阅</el-dropdown-item>
                        <el-dropdown-item @click="action('done')">设置已办</el-dropdown-item>
                        <el-dropdown-item @click="action('allread')" divided>设置全部已阅</el-dropdown-item>
                        <el-dropdown-item @click="action('alldone')">设置全部已办</el-dropdown-item>
                        <el-dropdown-item @click="download()" divided>导出列表</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
            <el-button type="danger" icon="delete" @click="deleter()">删除</el-button>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:title="scope">
                <el-text size="small" type="primary" @click.stop="watcher(scope.row)" style="cursor: pointer;">
                    {{ scope.row.title }}
                </el-text>
            </template>
            <template v-slot:done="scope">
                <div @click="watcher(scope.row)" style="cursor: pointer;">
                    <el-text v-if="scope.row.done == true" size="small" type="info">已处理</el-text>
                    <el-text v-if="scope.row.done === false" size="small" type="danger">未处理</el-text>
                </div>
            </template>
            <template v-slot:seen="scope">
                <div @click="watcher(scope.row)" style="cursor: pointer;">
                    <el-text v-if="scope.row.seen == true" size="small" type="info">已阅读</el-text>
                    <el-text v-if="scope.row.seen === false" size="small" type="danger">未阅读</el-text>
                </div>
            </template>

            <template v-slot:toolbar="scope">
                <el-button plain @click="watcher(scope.row)" type="primary" size="small">查看</el-button>
                <el-button plain @click="deleter(scope.row)" type="danger" size="small"
                    style="margin-left:5px;">删除</el-button>
            </template>
        </basic-table>



    </el-card>
</template>

<script>
import BasicTable from "@/components/basic-table.vue";

export default {
    name: "BaseMessage",
    components: { BasicTable },
    data() {
        return {
            categoryFilter: '',
            query: {
                keyword: "",
                columns: [
                    { type: "selection", width: "55" },
                    { type: "index", label: "序号" },

                    { type: "template", prop: "title", label: "消息标题", width: "280", align: 'left', sortable: true, searchable: true, showOverflowTooltip: true },
                    { prop: "category", label: "消息类型", width: "140", align: 'left', sortable: true, searchable: true, showOverflowTooltip: true },
                    { type: "hidden", prop: "pageUrl" },
                    { type: "hidden", prop: "apiUrl" },
                    { prop: "subTitle", label: "副标题", width: "350", align: 'left', sortable: true, searchable: true, showOverflowTooltip: true },

                    { prop: "targetUserName", label: "接收用户", width: "70", align: 'center', showOverflowTooltip: true },
                    { prop: "sourceUserName", label: "消息来源", width: "70", align: 'center', showOverflowTooltip: true },

                    { type: "template", prop: "done", label: "已处理", sortable: true, width: "80", align: 'center', showOverflowTooltip: true },
                    { type: "template", prop: "seen", label: "已阅读", sortable: true, width: "80", align: 'center', showOverflowTooltip: true },

                    { prop: "remark", label: "备注", searchable: true, width: "130", showOverflowTooltip: true },

                    { prop: "createUserName", label: "创建人", searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "createDate", label: "创建时间", sortable: true, width: "160", showOverflowTooltip: true },
                    { prop: "updateUserName", label: "更新人", searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "updateDate", label: "更新时间", sortable: true, width: "160", showOverflowTooltip: true },

                    { type: "toolbar", label: "操作", width: "130" },
                ],
                filters: [],
                sidx: "id",
                sord: "desc"
            },
        };
    },
    mounted() {
        //kaung插件初始化
        this.$kaung.init(this.$options.name);
        this.fetchs();
    },
    methods: {
        fetchs() {
            this.query.filters = [];
            if (this.categoryFilter) {
                this.query.filters.push({ name: 'category', value: '%' + this.categoryFilter + '%', operate: 5 });
            }
            let { data, records, total, ...params } = { ...this.query };
            this.$kaung.search(params).then((res) => {
                this.query = { ...res.data };
            });
        },
        download() {
            let { data, records, total, ...params } = { ...this.query };
            this.$kaung.export(params).then((res) => {
                this.$notify({
                    title: '表格数据导出',
                    message: res.content,
                    type: res.type,
                    duration: 10000
                });
                window.location.href = process.env.VUE_APP_BASEURL + res.data;
            });
        },

        deleter(row) {
            let targetRow = row || this.$refs.table.chooseRow;
            if (!targetRow) {
                this.$message({ message: '请点击选择要删除的数据行', type: 'warning' });
                return;
            }

            let that = this;
            this.$confirm("此操作将删除本页选择数据, 是否继续?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
                .then(() => {
                    this.$kaung.delete(targetRow.id).then((res) => {
                        if (res.code === 200) {
                            that.$message({ message: res.content, type: res.type });
                            that.fetchs();
                            that.refreshUnreadMessageCount();
                        }
                    });
                });
        },
        watcher(row) {
            if (!row) return;

            // 跳转到消息详情页面
            this.$router.push(`/sys/message/detail/${row.id}`);
        },

        action(typer, rowId) {
            typer = typer || 'read'; //read/done

            let title = '';
            if (typer == 'read')
                title = '确认将已勾选的数据设置为已阅, 是否继续?';
            else if (typer == 'done')
                title = '确认将已勾选的数据设置为已办/已处理（本操作仅处理消息的待办状态，如涉及流程或者出入库操作，依旧需自行操作处理）, 是否继续?';
            else if (typer == 'allread')
                title = '确认将系统全部消息设置为已阅, 是否继续?';
            else if (typer == 'alldone')
                title = '确认将系统全部消息设置为已办/已处理（本操作仅处理消息的待办状态，如涉及流程或者出入库操作，依旧需自行操作处理）, 是否继续?';

            let rowIds = [];

            rowId = rowId || '';
            if (rowId == null || rowId == '') {
                if (this.$refs.table.chooseRow)
                    rowIds.push(this.$refs.table.chooseRow.id);
                if (this.$refs.table.selectIds && this.$refs.table.selectIds.length > 0)
                    rowIds.push(...this.$refs.table.selectIds);
            } else {
                rowIds.push(rowId);
            }
            rowIds = [...new Set(rowIds)];//去重
            // if (rowIds.length == 0) {
            //     this.$kaung.message('请选择或者勾选其中一个要操作的数据');
            //     return;
            // }

            this.$confirm(title, "操作提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
                .then(() => {
                    this.$kaung.fetch({ url: '/BaseMessage/MarkData?typer=' + typer, method: 'post', data: rowIds }).then((res) => {
                        if (res.code === 200) {
                            this.$message({ message: res.content, type: res.type });
                            this.fetchs();
                            this.refreshUnreadMessageCount();
                        }
                    });
                });
        },
        refreshUnreadMessageCount() {
            this.$store.dispatch('fetchUnreadMessageCount').catch((error) => {
                console.log('刷新未读消息数量失败:', error);
            });
        },
    },
};
</script>
